const ACpricingConfig = {
    Split: {
      "10": {
        "3year": { subscription: 1399, depositamount: 5000 ,installetionCharge:1800},
        "5years": { subscription: 1099, depositamount: 5000 ,installetionCharge:1800},
        "3+2year": { subscription: 1349, depositamount: 5000, priceAfter3Years: 899, installetionCharge:1800},
      },
      "15": {
        "3year": { subscription: 1399, depositamount: 6000,installetionCharge:1800 },
        "5years": { subscription: 1199, depositamount: 6000,installetionCharge:1800 },
        "3+2year": { subscription: 1399, depositamount: 6000, priceAfter3Years: 899 ,installetionCharge:1800},
      },
      "20": {
        "3year": { subscription: 1699, depositamount: 7000,installetionCharge:1800 },
        "5years": { subscription: 1499, depositamount: 7000 ,installetionCharge:1800},
        "3+2year": { subscription: 1699, depositamount: 7000, priceAfter3Years: 1099,installetionCharge:1800 },
      },
    },
    Cassette: {
      "20": {
        "3+2year": { subscription: 2499, depositamount: 12000, priceAfter3Years: 1499,installetionCharge:4000 },
        "3year": { subscription: 2499, depositamount: 12000, priceAfter3Years: 1499,installetionCharge:4000 },
      },
      "30": {
        "3+2year": { subscription: 2999, depositamount: 15000, priceAfter3Years: 1999 ,installetionCharge:4000},
        "3year": { subscription: 2999, depositamount: 15000, priceAfter3Years: 1999 ,installetionCharge:4000},
      },
    },
  };
  
  export default ACpricingConfig;